export const existNameDialog = (function () {
  const error = ({ title = null } = {}, callback = () => {}) => {
    if (!title) return;

    const template = require('./tmpl/dialog/error-existname.hbs');
    bootbox
      .dialog({
        title: '<i class="fal fa-exclamation-triangle text-danger mr-2"></i> ' + $lang.error.namealreadyexists.title,
        message: template({ title: title, $lang: $lang }),
        size: 'large',
        className: 'error-existname-dialog',
        buttons: {
          Ok: {
            label: $lang.btn.ContinueSaving,
            className: 'btn disabled btn-brand js-action-continuesave',
            callback: (e) => {
              const newName = $('.error-existname-dialog [name="newProductName"]').val();
              if (newName) {
                callback({ newName: newName });
              }
            }
          },
          Close: {
            label: $lang.btn.cancel,
            className: 'btn btn-link'
          }
        }
      })
      .init(() => {
        const saveBtn = $('.error-existname-dialog .js-action-continuesave');
        saveBtn.removeClass('disabled').prop('disabled', true);
        $('.error-existname-dialog [name="newProductName"]').on('keyup', (e) => {
          const target = $(e.target);
          const val = target.val();
          saveBtn.prop('disabled', !val || val == title);
        });
      });
  };

  const confirm = ({ title = null } = {}, callback = () => {}) => {
    if (!title) return;

    bootbox.dialog({
      title: 'Product name will be changed',
      message: `<p><b>Product name is automatically generated:</b><br>${title}</p><p>You can edit it in the Store Data</p>`,
      size: 'large',
      className: 'error-existname-dialog',
      buttons: {
        Ok: {
          label: $lang.btn.ContinueSaving,
          className: 'btn btn-brand',
          callback: (e) => {
            callback({ newName: title });
          }
        },
        Close: {
          label: $lang.btn.cancel,
          className: 'btn btn-link'
        }
      }
    });
  };

  return {
    error,
    confirm
  };
})();
